import { AHInput } from "arkh";
import React from "react";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { LIST_ITEM_HEIGHT } from "../../../KPIAdmin/components/ListItem";

export function WATitleInput(props: {
  value: string;
  onChangeText(_: string): void;
}) {
  const intl_tokens = useIntlTokens();

  return (
    <AHInput
      value={props.value}
      onChangeText={props.onChangeText}
      color="surface"
      cornerRadius="large"
      defaultStyle
      spaceHorizontal="medium"
      style={{
        height: LIST_ITEM_HEIGHT,
      }}
      textType="title-small"
      placeholder={intl_tokens.Title}
    />
  );
}
